import { Button, Icon, Popover } from "antd";
import React from "react";
import "../../components/general/drawer/AdaptiveDrawer.css";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { handleError } from "../../utils/ErrorHandlers";
import { Constants } from "../../data/constants";
import { FileService } from "../../services/file/FileService";

class AudioPlayer extends React.Component {
  moveBy = 3;
  constructor(props) {
    super(props);

    this.constants = new Constants();
    this.fileService = new FileService();

    this.state = {
      isFetching: false,
      uploading: false,
      audio: null,
      play: false,
      firstTime: true,
      visible: false,
    };
  }
  async getVoiceMailAudioFile() {
    try {
      this.setState({ isFetching: true });
      let response = await this.fileService.downloadVoiceMail(
        this.props.context.session_id,
        this.props.record.cdrId
      );
      let audio = new Audio(response);
      audio.addEventListener("ended", this.stopPlaying.bind(this));
      this.setState(
        { audio: audio, isFetching: false, firstTime: false },
        () => {
          if (this.state.visible) this.startPlaying();
        }
      );
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }
  async getAudioFile() {
    try {
      this.setState({ isFetching: true });
      let response = await this.fileService.downloadCallRecord(
        this.props.context.session_id,
        this.props.record.cdrId
      );
      let audio = new Audio(response);
      audio.addEventListener("ended", this.stopPlaying.bind(this));
      this.setState(
        { audio: audio, isFetching: false, firstTime: false },
        () => {
          if (this.state.visible) this.startPlaying();
        }
      );
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }
  async getPromptFile() {
    try {
      this.setState({ isFetching: true });
      let response = await this.fileService.downloadPromptToPlay(
        this.props.context.session_id,
        this.props.record.fileId ? this.props.record.fileId : this.props.record.voiceMsg.fileId
      );

      let audio = new Audio(response);
      audio.addEventListener("ended", this.stopPlaying.bind(this));
      this.setState(
        { audio: audio, isFetching: false, firstTime: false },
        () => {
          if (this.state.visible) this.startPlaying();
        }
      );
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  togglePlay() {
    const { play, audio } = this.state;
    if (!audio) return;
    this.setState({ play: !play }, () => {
      if (audio.paused) {
        audio.play();
      }
      if (!this.state.play) {
        if (!audio.buffered.length) return;
        audio.pause();
      }
    });
  }

  stopPlaying() {
    const { audio } = this.state;
    this.setState({ play: false }, () => {
      audio.pause();
      audio.currentTime = 0;
    });
  }

  startPlaying() {
    const { audio } = this.state;
    this.setState({ play: true }, () => {
      audio.currentTime = 0;
      audio.play();
    });
  }

  async onVisibleChange(visible) {
    await this.setState({ visible });
    const { firstTime, audio, isFetching } = this.state;

    if (visible && firstTime && this.props.type === "record") {
      await this.getAudioFile();
    } else if (visible && firstTime && this.props.type === "voiceMail") {
      await this.getVoiceMailAudioFile();
    } else if (visible && firstTime && this.props.type === "prompt") {
      
      await this.getPromptFile();
    }
    if (!isFetching && audio) {
      if (visible) {
        this.setState({ play: true }, () => {
          audio.play();
        });
      } else {
        this.setState({ play: false }, () => {
          audio.pause();
        });
      }
    }
  }

  skipPartForward() {
    const { audio } = this.state;
    if (!audio) return;
    audio.currentTime += this.moveBy;
  }

  skipPartBackward() {
    const { audio } = this.state;
    if (!audio) return;
    audio.currentTime -= this.moveBy;
  }

  render() {
    let { play, isFetching } = this.state;
    return (
      <>
        <Popover
          placement="top"
          onVisibleChange={(visible) => this.onVisibleChange(visible)}
          content={
            isFetching ? (
              <Button color="#000000a6" size="small" shape="circle" loading />
            ) : (
              <div>
                <Button
                  color="#000000a6"
                  size="small"
                  shape="circle"
                  onClick={() => {
                    if(this.props.context.curr_dir === "ltr"){
                      this.skipPartBackward() 
                    }else{
                      this.skipPartForward()
                    }
                     
                  }
                    }
                >
                  <Icon
                    type={
                      this.props.context.curr_dir === "ltr"
                        ? "double-left"
                        : "double-right"
                    }
                  />
                </Button>

                <Button
                  color="#000000a6"
                  size="small"
                  style={{ margin: "0px 5px" }}
                  shape="circle"
                  onClick={() => this.togglePlay()}
                >
                  <Icon type={play ? "pause" : "caret-right"} />
                </Button>

                <Button
                  color="#000000a6"
                  size="small"
                  shape="circle"
                  onClick={() =>{ 
                    if(this.props.context.curr_dir === "ltr"){
                      this.skipPartForward()

                    }else{
                      this.skipPartBackward() 
                    }
                    
                    
                  }}
                >
                  <Icon
                    type={
                      this.props.context.curr_dir === "ltr"
                        ? "double-right"
                        : "double-left"
                    }
                  />
                </Button>
              </div>
            )
          }
          trigger="click"
        >
          {
            this.props.disabled ? (
              <Icon type="stop" theme="outlined" twoToneColor="#27ae60" style={{
                cursor: "not-allowed",
                pointerEvents: "none",
              }} />
            ) : (

              play ? (
                <Icon type="sound" theme="twoTone" twoToneColor="#27ae60" />
              ) : (
                <Icon type="sound" />
              )
            )
          }
        </Popover>
        {this.props.label && <span>&nbsp;{this.props.label}</span>}
      </>
    );
  }
}

export default withSharedStateConsumer(AudioPlayer);
